// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'times';

export const Component = () => (
  <path d='m12.511 13.925-.18.18-6.987 6.96-.377.375-.198.197-.21.21-.045.045-.06.06L3 20.625l.026-.027 8.061-8.097-.619-.618L8.464 9.88l-.814-.81-.262-.263-.76-.758-.71-.71-.44-.44-.61-.608-.366-.366-.17-.17-.458-.458-.472-.472-.401-.4.054-.055 1.298-1.315L4.407 3l.006.007.227.226.175.175.345.345.136.136.822.82.19.191.62.618.922.922.755.754 1.353 1.352.567.566.288.288.878.876.296.296.512.511.013-.012.587-.59 7.138-7.171.15-.15.056-.056.096-.097.007-.007L22 4.473l-.06.06-.045.045-.129.127-.279.279-.377.375-7.18 7.153.443.443 1.46 1.46.568.566.279.279 1.074 1.073.257.257.498.497.24.24.683.682.214.214.405.404.71.71.438.437.125.126.395.394.174.173.06.06h-.001l-.052.057L20.595 22l-.16-.16-1.341-1.34-.562-.561-.203-.203-.652-.65-.71-.71-.759-.758-.263-.263-.813-.812-.844-.844-.867-.866-.293-.293-.617-.615Z' />
);

export const viewBox = '0 0 25 25';
